export interface RowLockInfo {
  lockedBy?: string | null
  lockedByName?: string | null
}

export interface RowLockResult {
  rowLockedByPeer: boolean
  lockTitle: string | null
}

/**
 * Derives peer-lock visual state for Manage rows and BoardExplorer tiles.
 * A row is considered locked by peer if an active external lock exists and
 * is held by someone other than the current user.
 */
export function isRowLockedByPeer(
  lock: RowLockInfo | null | undefined,
  currentUid?: string | null,
): RowLockResult {
  if (!lock || !lock.lockedBy || (currentUid && lock.lockedBy === currentUid)) {
    return {
      rowLockedByPeer: false,
      lockTitle: null,
    }
  }

  const name = lock.lockedByName || 'another user'
  return {
    rowLockedByPeer: true,
    lockTitle: `Locked by ${name}`,
  }
}
